<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view class="child-view" />
    </transition>

    <cube-tab-bar v-if="isShowBar && !isPc"
                  v-model="selectLabel"
                  @change="changeHandler">
      <cube-tab v-for="(item, index) in tabs"
                :key="index"
                :icon="item.icon"
                :label="item.value">
        <span>{{item.label}}</span>
        <!-- <span class="badge" v-if="showBadge(item.label)">{{cartTotal}}</span> -->
      </cube-tab>
    </cube-tab-bar>
    <!-- <div v-else class="cube-tab-bar" @click="changeHandler('/')">
      <div class="cube-tab">
        <i :class="tabs[0].icon"></i>
        <span>{{tabs[0].label}}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      isPc: false,
      isShowBar: true,
      homePage: "Home",
      selectLabel: "/", // 默认页签
      tabs: [
        { label: "课程", value: "/", icon: "cubeic-home" },
        { label: "我的", value: "/login", icon: "cubeic-person" }
      ],
      transitionName: "route-forward"
    };
  },
  watch: {
    // 路由发生变化时，同步tabs选中
    $route (route) {
      let tabsValue = [];
      this.tabs.forEach(i => {
        tabsValue.push(i.value);
      });
      // 非tabs中路由显示回到主页tab
      this.isShowBar = tabsValue.includes(route.path) && this.$store.getters.token ? true : false;
      this.selectLabel = route.path;
      // 动态设置动画方式
      this.transitionName = this.$router.transitionName;
    }
  },
  created () {
    // 初始化页签设置
    this.selectLabel = this.$route.path;
    this.isPc = this.IsPCVisted();
  },
  methods: {
    logout () {
      //this.$http.get("/api/logout");
    },
    changeHandler (val) {
      this.$router.push(val);
    },
    showBadge (label) {
      return label == "Cart" && this.cartTotal > 0;
    },
    IsPCVisted() {
      if (window.innerWidth < 768) return false;
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod", "Mobi", "Mobile"];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) !== -1) {
          return false;
        }
      }
      return true;
    },
  },
  computed: {
    ...mapGetters(["isLogin", "cartTotal"])
  }
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.cube-tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: none;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  z-index: 100;
  padding: 4px 0 8px;
  height: 40px;
}

.cube-tab {
  padding: 6px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.cube-tab i {
  font-size: 22px;
  color: #bbb;
  transition: color 0.2s;
}

.cube-tab span {
  font-size: 11px;
  color: #bbb;
  transition: color 0.2s;
}

.cube-tab_active i {
  color: #667eea;
}

.cube-tab_active span {
  color: #667eea;
  font-weight: 600;
}

.cube-tab-bar-slider {
  display: none;
}
/* 页面滑动动画 */
/* 入场前 */
.route-forward-enter {
  transform: translate3d(-100%, 0, 0);
}
.route-back-enter {
  transform: translate3d(100%, 0, 0);
}
/* 出场后 */
.route-forward-leave-to {
  transform: translate3d(100%, 0, 0);
}
.route-back-leave-to {
  transform: translate3d(-100%, 0, 0);
}
.route-forward-enter-active,
.route-forward-leave-active,
.route-back-enter-active,
.route-back-leave-active {
  transition: transform 0.3s;
}

.child-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

span.badge {
  display: inline-block;
  background: #de3529;
  color: white;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
</style>
